/* eslint-disable */
import _has from 'lodash/has';
import _unset from 'lodash/unset';
import { mapGetters} from "vuex";

export default {


    methods: {
        getProject() {
            let project = localStorage.PORTAL_PROJECT || [];
            return JSON.parse(project)
        },
        getClient() {
            let client = localStorage.PORTAL_CLIENT || [];
            return JSON.parse(client)
        },
        async logout(){
            await this.$http.post(this.app.version + '/front/agreement/logout').catch((error) => {
                swal({
                    title: 'Error',
                    icon: 'error',
                    text: error.response.data.message
                })
            });

            this.$auth.destroyToken();
            localStorage.removeItem('PORTAL_PROJECT')
            localStorage.removeItem('PORTAL_CLIENT')
            this.$router.push({path:'/login/' + localStorage.PORTAL_HASH });
            this.isAuth=false;
            localStorage.removeItem('PORTAL_HASH')
        },

        getValidationState : function(field){
            return _has(this.error.errors,field)
        },
        getInvalidFeedback : function(field){
            if( _has(this.error.errors,field) ){
                return  this.error.errors[field][0];
            }
            return null;
        },
        clearState : function(field){
            if( _has(this.error.errors, field ) ){
                _unset( this.error.errors ,  field );
            }
        },
    }
}
